import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_EXPORT_LINK', function (downloadLink) {
    getStore().downloadLink = downloadLink;
});
//# sourceMappingURL=setExportLink.js.map